import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../services/toast.service'; 

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  toast = {
    message: '',
    type: 'info' as 'success' | 'error' | 'info',  
    isVisible: false,
  };

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastService.toast$.subscribe((toast) => {
      this.toast.message = toast.message;
      this.toast.type = toast.type;
      this.toast.isVisible = true;

      setTimeout(() => this.hideToast(), 3000);
    });
  }

  hideToast() {
    this.toast.isVisible = false;
  }
}
